export default __webpack_public_path__ + "static/media/photo--sm--janie.b51aad05.jpg";